export var COLORS;
(function (COLORS) {
  COLORS["BLACK"] = "#191c22";
  COLORS["GRAY_INACTIVE"] = "#bebec9";
  COLORS["RED"] = "#fa3300";
})(COLORS || (COLORS = {}));
export var STORY_MOBILE_HEIGHT = '--storyMobileHeight';